import { ThemeDefinition } from 'vuetify';

export const light: ThemeDefinition = {
  dark: false,
  colors: {
    'brand-original': '#005eb8',
    'on-brand-original': '#ffffff',
    brand: '#005eb8',
    'on-brand': '#ffffff',
    'accent-original': '#50c8b2',
    'on-accent-original': '#ffffff',
    accent: '#298473',
    'on-accent': '#ffffff',
    primary: '#004c94',
    'on-primary': '#ffffff',
    'primary-container': '#b3dbff',
    'on-primary-container': '#00203d',
    secondary: '#3e5a74',
    'on-secondary': '#ffffff',
    'secondary-container': '#cdd9e4',
    'on-secondary-container': '#151f28',
    tertiary: '#1f6155',
    'on-tertiary': '#ffffff',
    'tertiary-container': '#c5ede5',
    'on-tertiary-container': '#0f2f29',
    surface: '#f8fafb',
    'on-surface': '#1d1f20',
    'on-surface-medium': '#55595e',
    'on-surface-low': '#94999e',
    outline: '#798086',
    'outline-variant': '#cacdcf',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#303336',
    'inverse-on-surface': '#fafafa',
    'inverse-primary': '#b2daff',
    'primary-fixed': '#b2daff',
    'primary-fixed-dim': '#70baff',
    'on-primary-fixed': '#00203d',
    'secondary-fixed': '#cdd9e4',
    'secondary-fixed-dim': '#9fb6cb',
    'on-secondary-fixed': '#151f28',
    'tertiary-fixed': '#c5ede5',
    'tertiary-fixed-dim': '#8bdacc',
    'on-tertiary-fixed': '#0f2f29',
    'surface-dim': '#cad7e2',
    'surface-bright': '#fcfcfd',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#f2f5f8',
    'surface-container': '#e8edf3',
    'surface-container-high': '#dee6ed',
    'surface-container-highest': '#d7e1ea',
    success: '#449c48',
    'on-success': '#ffffff',
    'success-container': '#cde9ce',
    'on-success-container': '#173518',
    'success-surface': '#f8fcf8',
    'on-success-surface': '#2a602c',
    warning: '#db7a00',
    'on-warning': '#ffffff',
    'warning-container': '#ffdfb8',
    'on-warning-container': '#4d2a00',
    'warning-surface': '#fffaf5',
    'on-warning-surface': '#804700',
    error: '#a32929',
    'on-error': '#ffffff',
    'error-container': '#f1c6c6',
    'on-error-container': '#3d0f0f',
    'error-surface': '#fdf7f7',
    'on-error-surface': '#9f2828',
    info: '#0d8df2',
    'on-info': '#ffffff',
    'info-container': '#bbdffb',
    'on-info-container': '#042a49',
    'info-surface': '#f5fafe',
    'on-info-surface': '#085491',
  },
};

export const dark: ThemeDefinition = {
  dark: true,
  colors: {
    'brand-original': '#005eb8',
    'on-brand-original': '#f5faff',
    brand: '#08355e',
    'on-brand': '#cce6ff',
    'accent-original': '#51c8b2',
    'on-accent-original': '#0f2f29',
    accent: '#184e44',
    'on-accent': '#d8f3ee',
    primary: '#a8d5ff',
    'on-primary': '#00203d',
    'primary-container': '#004f99',
    'on-primary-container': '#f5faff',
    secondary: '#c3d2df',
    'on-secondary': '#151f28',
    'secondary-container': '#364d63',
    'on-secondary-container': '#f8fafb',
    tertiary: '#9ee0d4',
    'on-tertiary': '#0f2f29',
    'tertiary-container': '#1f6155',
    'on-tertiary-container': '#f7fdfc',
    surface: '#111518',
    'on-surface': '#f2f2f3',
    'on-surface-medium': '#c9cccf',
    'on-surface-low': '#798086',
    outline: '#94999e',
    'outline-variant': '#61666b',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#e4e6e7',
    'inverse-on-surface': '#1d1f20',
    'inverse-primary': '#00468a',
    'primary-fixed': '#b2daff',
    'primary-fixed-dim': '#70baff',
    'on-primary-fixed': '#00203d',
    'secondary-fixed': '#cdd9e4',
    'secondary-fixed-dim': '#9fb6cb',
    'on-secondary-fixed': '#151f28',
    'tertiary-fixed': '#c5ede5',
    'tertiary-fixed-dim': '#8bdacc',
    'on-tertiary-fixed': '#0f2f29',
    'surface-dim': '#0f1215',
    'surface-bright': '#323b43',
    'surface-container-lowest': '#0d1012',
    'surface-container-low': '#161a1d',
    'surface-container': '#1c2125',
    'surface-container-high': '#252c32',
    'surface-container-highest': '#303841',
    success: '#addbaf',
    'on-success': '#173518',
    'success-container': '#2e6b31',
    'on-success-container': '#f8fcf8',
    'success-surface': '#0c1c0d',
    'on-success-surface': '#aadaac',
    warning: '#ffcb8a',
    'on-warning': '#4d2a00',
    'warning-container': '#995500',
    'on-warning-container': '#fffaf5',
    'warning-surface': '#291700',
    'on-warning-surface': '#ffc47a',
    error: '#e8a1a1',
    'on-error': '#3d0f0f',
    'error-container': '#7a1f1f',
    'on-error-container': '#fdf7f7',
    'error-surface': '#210808',
    'on-error-surface': '#f0c2c2',
    info: '#90caf9',
    'on-info': '#042a49',
    'info-container': '#085691',
    'on-info-container': '#f5fafe',
    'info-surface': '#021727',
    'on-info-surface': '#a3d4fa',
  },
};
